import { render } from "./ServiceItsCallActionComp.vue?vue&type=template&id=1583c0c4&scoped=true"
import script from "./ServiceItsCallActionComp.vue?vue&type=script&lang=js"
export * from "./ServiceItsCallActionComp.vue?vue&type=script&lang=js"

import "./ServiceItsCallActionComp.vue?vue&type=style&index=0&id=1583c0c4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1583c0c4"]])

export default __exports__